import { render, staticRenderFns } from "./Meta3d.vue?vue&type=template&id=ee715256&scoped=true&"
import script from "./Meta3d.vue?vue&type=script&lang=js&"
export * from "./Meta3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee715256",
  null
  
)

export default component.exports